import type { ExportPostsReviewToggleHandler } from "./export-posts-review-toggle-handler";

export class ExportPostsReviewToggleListener {
    private handler: ExportPostsReviewToggleHandler;

    public constructor(handler: ExportPostsReviewToggleHandler) {
        this.handler = handler;
    }

    public register(select: HTMLSelectElement, field: HTMLElement): void {
        select.addEventListener("change", () => {
            this.handler.applyVisibility(select, field);
        });
    }
}
